export default "__VITE_ASSET__62bef898__"